(function () {
  'use strict';

  var ROOT_SELECTOR = '.dialog-body, .room-caption, #hotspots, .room-doors';
  var UNIT_CLASS = 'lsdfs-ja-unit';
  var SKIP_SELECTOR = 'script,style,textarea,input,select,option,svg,canvas,[contenteditable="true"],.' + UNIT_CLASS + ',[data-no-ja-wrap]';
  var JAPANESE = /[\u3040-\u30ff\u3400-\u9fff\uf900-\ufaff々〆ヵヶー]/;
  var SPACE = /^\s+$/;
  var CLOSING = /^[、。，．！？!?：:；;…・）\)」』】〉》〕］｝」』】〗〙〛。、]+$/;
  var OPENING = /^[（\(「『【〈《〔［｛〖〘〚]+$/;
  var ATTACH_PREVIOUS = /^(?:さん|ちゃん|くん|君|氏|様|たち|達|ら|の|に|は|を|が|と|で|へ|も|や|から|まで|より|って|だけ|しか|ので|のに|なら|では|には|とは|とか|でも|ならば|です|ます|ま|した|でした|ました|た|て|ない|なかった)$/;
  var HAN = /^[\u3400-\u9fff\uf900-\ufaff々〆ヵヶ]+$/;
  var HIRAGANA = /^[ぁ-んゝゞ]+$/;
  var PROTECTED_WORDS = /(オガさん|タケちゃん|颯斗くん|ダッチオーブン|ガーリック|バター|感謝|ガイド|アオリイカ|チェック|オリーブオイル|黒胡椒|プライヤー|サングラス|シミュレーション)/g;
  var segmenter = typeof Intl !== 'undefined' && Intl.Segmenter
    ? new Intl.Segmenter('ja', { granularity: 'word' })
    : null;

  function fallbackSegments(text) {
    return text.match(/\s+|[ァ-ヶー]+|[一-龯々〆ヵヶ]+|[ぁ-ん]+|[A-Za-z0-9][A-Za-z0-9._\/-]*|./gu) || [text];
  }

  function segments(text) {
    return text.split(PROTECTED_WORDS).flatMap(function (part, index) {
      if (!part) return [];
      if (index % 2) return [part];
      if (!segmenter) return fallbackSegments(part);
      return Array.from(segmenter.segment(part), function (item) { return item.segment; });
    });
  }

  function buildUnits(text) {
    var raw = segments(text);
    var units = [];
    var pendingOpening = '';

    raw.forEach(function (part) {
      if (!part) return;
      if (SPACE.test(part)) {
        if (pendingOpening) {
          units.push({ text: pendingOpening, nowrap: true });
          pendingOpening = '';
        }
        units.push({ text: part, nowrap: false });
        return;
      }

      if (OPENING.test(part)) {
        pendingOpening += part;
        return;
      }

      part = pendingOpening + part;
      pendingOpening = '';
      var previous = units.length ? units[units.length - 1] : null;
      var joinsSplitName = previous && previous.nowrap && HAN.test(previous.text) && HAN.test(part) &&
        Array.from(previous.text).length < 4 && Array.from(part).length === 1;
      var joinsConjugation = previous && previous.nowrap && HIRAGANA.test(part) &&
        (HIRAGANA.test(previous.text) || HAN.test(previous.text));
      if (previous && previous.nowrap && (CLOSING.test(part) || ATTACH_PREVIOUS.test(part) || joinsSplitName || joinsConjugation)) {
        previous.text += part;
      } else {
        units.push({ text: part, nowrap: true });
      }
    });

    if (pendingOpening) units.push({ text: pendingOpening, nowrap: true });
    return units;
  }

  function eligible(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue || !JAPANESE.test(node.nodeValue)) return false;
    var parent = node.parentElement;
    return parent && !parent.closest(SKIP_SELECTOR);
  }

  function wrapTextNode(node) {
    if (!eligible(node)) return;
    var units = buildUnits(node.nodeValue);
    if (units.length < 2) return;
    var parent = node.parentElement;
    var display = getComputedStyle(parent).display;
    var isLayout = /^(?:inline-)?(?:flex|grid)$/.test(display);
    var fragment = document.createDocumentFragment();
    units.forEach(function (unit) {
      if (!unit.nowrap) {
        fragment.appendChild(document.createTextNode(unit.text));
        return;
      }
      var span = document.createElement('lsd-phrase');
      span.className = UNIT_CLASS;
      span.textContent = unit.text;
      fragment.appendChild(span);
    });
    if (isLayout) {
      var flow = document.createElement('lsd-text');
      flow.appendChild(fragment);
      parent.replaceChild(flow, node);
    } else {
      parent.replaceChild(fragment, node);
    }
  }

  function wrapRoot(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
    var roots = [];
    if (root.matches && root.matches(ROOT_SELECTOR)) roots.push(root);
    if (root.querySelectorAll) roots = roots.concat(Array.from(root.querySelectorAll(ROOT_SELECTOR)));
    roots.forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) if (eligible(walker.currentNode)) nodes.push(walker.currentNode);
      nodes.forEach(wrapTextNode);
    });
  }

  var queued = false;
  var observer = new MutationObserver(function (records) {
    if (!records.some(function (record) {
      return !record.target.closest?.('.' + UNIT_CLASS + ',lsd-text') &&
        Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === Node.TEXT_NODE ||
            (node.nodeType === Node.ELEMENT_NODE && !node.matches('lsd-phrase,lsd-text'));
        });
    })) return;
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      wrapRoot(document.documentElement);
    });
  });

  function start() {
    wrapRoot(document.documentElement);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

